module.exports = __webpack_public_path__ + "img/qianfei.7c38fed6.png";